export default __webpack_public_path__ + "/fonts/Beeline_Sans-Regular.eot";